import dayjs from 'dayjs';

import {
  organizationBackdoorLsKey,
  organizationIdLsKey,
  organizationSessionStorageInitializedLsKey,
} from '@ll-platform/frontend/consts/organization';
import type { Organization } from '@ll-platform/frontend/core/organization/types';
import { defined } from '@ll-platform/shared-utils/types';

class OrganizationService {
  constructor() {
    const isSessionStorageInitialized = this.getIsSessionStorageInitialized();

    if (!isSessionStorageInitialized) {
      this.initializeSessionStorage();
    }
  }

  initializeSessionStorage(): void {
    const localStorageOrganizationId =
      localStorage.getItem(organizationIdLsKey);
    const localStorageIsBackdoorOrganization = localStorage.getItem(
      organizationBackdoorLsKey,
    );

    if (defined(localStorageOrganizationId)) {
      sessionStorage.setItem(organizationIdLsKey, localStorageOrganizationId);
    }
    if (defined(localStorageIsBackdoorOrganization)) {
      sessionStorage.setItem(
        organizationBackdoorLsKey,
        localStorageIsBackdoorOrganization,
      );
    }

    sessionStorage.setItem(
      organizationSessionStorageInitializedLsKey,
      true.toString(),
    );
  }

  getIsSessionStorageInitialized(): boolean {
    return (
      sessionStorage.getItem(organizationSessionStorageInitializedLsKey) ===
      'true'
    );
  }

  getOrganizationId(): string | null {
    return sessionStorage.getItem(organizationIdLsKey) ?? null;
  }

  setOrganizationId(organizationId: string | null): void {
    if (!organizationId) {
      localStorage.removeItem(organizationIdLsKey);
      sessionStorage.removeItem(organizationIdLsKey);
    } else {
      localStorage.setItem(organizationIdLsKey, organizationId);
      sessionStorage.setItem(organizationIdLsKey, organizationId);
    }
  }

  setBackdoorOrganizationId(organizationId: string | null): void {
    this.setOrganizationId(organizationId);
    if (!organizationId) {
      localStorage.removeItem(organizationBackdoorLsKey);
      sessionStorage.removeItem(organizationBackdoorLsKey);
    } else {
      localStorage.setItem(organizationBackdoorLsKey, true.toString());
      sessionStorage.setItem(organizationBackdoorLsKey, true.toString());
    }
  }

  getIsBackdoorOrganization(): boolean {
    return (
      sessionStorage.getItem(organizationBackdoorLsKey) === 'true' &&
      !!this.getOrganizationId()
    );
  }

  makeFakeOrganization(organizationId: string): Organization {
    return {
      id: organizationId,
      name: `Unknown ${organizationId.slice(-6)}`,
      createdAt: dayjs(),
      updatedAt: dayjs(),
    };
  }

  promptForBackdoorOrganizationId(): void {
    const organizationId = prompt('Enter organization ID');
    this.setBackdoorOrganizationId(organizationId);
    window.location.reload();
  }
}

export const organizationService = new OrganizationService();
